var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66683 1.66671C3.45769 1.66671 1.66683 3.45757 1.66683 5.66671C1.66683 7.87585 3.45769 9.66671 5.66683 9.66671C7.87597 9.66671 9.66683 7.87585 9.66683 5.66671C9.66683 3.45757 7.87597 1.66671 5.66683 1.66671ZM0.333496 5.66671C0.333496 2.72119 2.72131 0.333374 5.66683 0.333374C8.61235 0.333374 11.0002 2.72119 11.0002 5.66671C11.0002 6.89918 10.5821 8.03401 9.88007 8.93714L13.4716 12.5286C13.7319 12.789 13.7319 13.2111 13.4716 13.4714C13.2112 13.7318 12.7891 13.7318 12.5288 13.4714L8.93726 9.87995C8.03414 10.582 6.8993 11 5.66683 11C2.72131 11 0.333496 8.61223 0.333496 5.66671Z",
    fill: "#A7ADAF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.a66d9cdf.svg";
export { ForwardRef as ReactComponent };